import { FormControl } from "@angular/forms";

export function UnitNumberValidator(control: FormControl) {
	if (control.value) {
		const unitNumberRegEx = /^(?!^[- ])(?!.*[- ]$)(([a-zA-Z0-9])+[-|\s]?([a-zA-Z0-9])*)*$/; // /^[0-9a-zA-Z]+$/;
		const valid = unitNumberRegEx.test(control.value);
		if (!valid) {
			return {
				unitNumberInvalid: {
					valid: false,
					message: "Invalid unit #",
				},
			};
		}
		return null;
	}
}
